import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import moment from 'moment'
import ActionHelper from 'helpers/action'

// constants
export const FETCH_ACTIVE_SITES = 'dl/FETCH_ACTIVE_SITES'
export const FETCH_ACTIVE_SITES_WITHOUT_SITE_TYPE =
  'dl/FETCH_ACTIVE_SITES_WITHOUT_SITE_TYPE'
export const SET_ACTIVE_SITES = 'dl/SET_ACTIVE_SITES'
export const FETCH_ACTIVE_CAGES = 'dl/FETCH_ACTIVE_CAGES'
export const SET_ACTIVE_CAGES = 'dl/SET_ACTIVE_CAGES'
export const SET_ACTIVE_CAGE = 'dl/SET_ACTIVE_CAGE'
export const SET_ACTIVE_DATE = 'dl/SET_ACTIVE_DATE'
export const FETCH_MYLOG_TABLE = 'dl/FETCH_MYLOG_TABLE'
export const SET_MYLOG_TABLE_DATA = 'dl/SET_MYLOG_TABLE_DATA'
export const CLEAR_MYLOG_TABLE_DATA = 'dl/CLEAR_MYLOG_TABLE_DATA'
export const RELOAD_MYLOG_TABLE_DATA = 'dl/RELOAD_MYLOG_TABLE_DATA'
export const FETCH_RATE_LOG_TABLE = 'dl/FETCH_RATE_LOG_TABLE'
export const SET_RATE_LOG_TABLE_DATA = 'dl/SET_RATE_LOG_TABLE_DATA'
export const CLEAR_RATE_LOG_TABLE_DATA = 'dl/CLEAR_RATE_LOG_TABLE_DATA'
export const RELOAD_RATE_LOG_TABLE_DATA = 'dl/RELOAD_RATE_LOG_TABLE_DATA'
export const FETCH_WIDGET_RATE_LOG_TABLE = 'dl/FETCH_WIDGET_RATE_LOG_TABLE'
export const SET_WIDGET_RATE_LOG_TABLE = 'dl/SET_WIDGET_RATE_LOG_TABLE'
export const CLEAR_WIDGET_RATE_LOG_TABLE = 'dl/CLEAR_WIDGET_RATE_LOG_TABLE'
export const RELOAD_WIDGET_RATE_LOG_TABLE = 'dl/CLEAR_WIDGET_RATE_LOG_TABLE'
export const REMOVE_LOG_ROW = 'dl/REMOVE_LOG_ROW'
export const FETCH_DATE_FILTER = 'dl/FETCH_DATE_FILTER'
export const SET_DATE_FILTER = 'dl/SET_DATE_FILTER'
export const FETCH_LOCUS_HISTORY = 'dl/FETCH_LOCUS_HISTORY'
export const SET_LOCUS_HISTORY = 'dl/SET_LOCUS_HISTORY'
export const EXPORT_TO_CSV = 'dl/EXPORT_TO_CSV'
export const RESET_STORE = 'dl/RESET_STORE'

// actions
export const fetchActiveSites = ActionHelper.createActionObj(FETCH_ACTIVE_SITES)
export const fetchActiveSitesWithoutSiteType = ActionHelper.createActionObj(
  FETCH_ACTIVE_SITES_WITHOUT_SITE_TYPE,
)
export const fetchActiveCages = ActionHelper.createActionObj(FETCH_ACTIVE_CAGES)
export const setActiveCage = ActionHelper.createActionObj(SET_ACTIVE_CAGE)
export const setActiveDate = ActionHelper.createActionObj(SET_ACTIVE_DATE)
export const fetchMyLogTable = ActionHelper.createActionObj(FETCH_MYLOG_TABLE)
export const fetchRateLogTable = ActionHelper.createActionObj(
  FETCH_RATE_LOG_TABLE,
)
export const fetchWidgetRateLogTable = ActionHelper.createActionObj(
  FETCH_WIDGET_RATE_LOG_TABLE,
)
export const clearMyLogTable = ActionHelper.createActionObj(
  CLEAR_MYLOG_TABLE_DATA,
)
export const clearRateLogTable = ActionHelper.createActionObj(
  CLEAR_RATE_LOG_TABLE_DATA,
)
export const clearWidgetRateLogTable = ActionHelper.createActionObj(
  CLEAR_WIDGET_RATE_LOG_TABLE,
)
export const reloadMyLogTable = ActionHelper.createActionObj(
  RELOAD_MYLOG_TABLE_DATA,
)
export const reloadRateLogTable = ActionHelper.createActionObj(
  RELOAD_RATE_LOG_TABLE_DATA,
)
export const reloadWidgetRateLogTable = ActionHelper.createActionObj(
  RELOAD_WIDGET_RATE_LOG_TABLE,
)
export const removeLogRow = ActionHelper.createActionObj(REMOVE_LOG_ROW)
export const fetchDateFilters = ActionHelper.createActionObj(FETCH_DATE_FILTER)
export const fetchDlMortalityLocusHistory = ActionHelper.createActionObj(
  FETCH_LOCUS_HISTORY,
)
export const exportToCsv = ActionHelper.createActionObj(EXPORT_TO_CSV)
export const resetStore = ActionHelper.createActionObj(RESET_STORE)

// store
const initialState = fromJS({
  isReloadMyLogTable: false,
  isReloadRateLogTable: false,
  isReloadWidgetRateLogTable: false,
  siteList: [],
  locusList: [],
  activeCage: 0,
  activeDate: moment(),
  myLogTable: {
    data: [],
    count: 0,
  },
  rateLogTable: {
    data: [],
    count: 0,
  },
  widgetRateLogTable: {
    data: [],
    count: 0,
  },
  mortalityActiveSiteList: [],
  mortalityDateFilters: [],
  mortalityLocusHistory: [],
})

const digitalLogbook = handleActions(
  {
    [SET_ACTIVE_SITES]: (state, action) =>
      state.set('siteList', List(action.list)),
    [SET_ACTIVE_CAGES]: (state, action) =>
      state.set('locusList', List(action.list)),
    [SET_ACTIVE_CAGE]: (state, action) =>
      state.set('activeCage', action.payload),
    [SET_ACTIVE_DATE]: (state, action) =>
      state.set('activeDate', action.payload),
    [SET_MYLOG_TABLE_DATA]: (state, action) =>
      state
        .set('myLogTable', Map(action.data))
        .set('isReloadMyLogTable', false),
    [SET_RATE_LOG_TABLE_DATA]: (state, action) =>
      state
        .set('rateLogTable', Map(action.data))
        .set('isReloadRateLogTable', false),
    [SET_WIDGET_RATE_LOG_TABLE]: (state, action) =>
      state
        .set('widgetRateLogTable', Map(action.data))
        .set('isReloadWidgetRateLogTable', false),
    [CLEAR_MYLOG_TABLE_DATA]: state =>
      state.set('myLogTable', Map({ data: [], count: 0 })),
    [CLEAR_RATE_LOG_TABLE_DATA]: state =>
      state.set('rateLogTable', Map({ data: [], count: 0 })),
    [CLEAR_WIDGET_RATE_LOG_TABLE]: state =>
      state.set('widgetRateLogTable', Map({ data: [], count: 0 })),
    [SET_DATE_FILTER]: (state, action) =>
      state.set('mortalityDateFilters', List(action.list)),
    [SET_LOCUS_HISTORY]: (state, action) =>
      state.set('mortalityLocusHistory', List(action.list)),
    [RELOAD_MYLOG_TABLE_DATA]: (state, action) =>
      state.set('isReloadMyLogTable', action.payload),
    [RELOAD_RATE_LOG_TABLE_DATA]: (state, action) =>
      state.set('isReloadRateLogTable', action.payload),
    [RELOAD_WIDGET_RATE_LOG_TABLE]: (state, action) =>
      state.set('isReloadWidgetRateLogTable', action.payload),
    [RESET_STORE]: state =>
      state
        .set('mortalityDateFilters', List([]))
        .set('mortalityActiveSiteList', List([]))
        .set('mortalityLocusHistory', List([])),
  },
  initialState,
)

export default digitalLogbook
